import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, tap } from 'rxjs';

import { ByocService } from '@app/byoc/popup/service/byoc.service';
import { Course } from '@app/core/model/library.model';
import { MessageService } from '@app/service/message.service';
import { ByocEpisodePopupService } from '../../../episode/service/popup.service';
import { ByocCourseService } from '../../service/course.service';

@Component({
    selector: 'app-byoc-course-step-warning',
    templateUrl: './warning-empty.component.html',
    styleUrls: ['./warning-empty.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ByocCourseStepWarningComponent {
    private readonly router = inject(Router);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly translateService = inject(TranslateService);
    private readonly messageService = inject(MessageService);
    private readonly byocService = inject(ByocService);
    private readonly byocCourseService = inject(ByocCourseService);
    private readonly byocEpisodePopupService = inject(ByocEpisodePopupService);

    saving = false;

    private subscriptions: Subscription = new Subscription();

    saveClick(): void {
        // set as draft
        this.byocCourseService.form.patchValue({ status: 2 });

        // show loader
        this.saving = true;
        this.changeDetectorRef.detectChanges();

        // save as draft and redirect with message
        this.subscriptions.add(
            this.byocService
                .createCourse(this.byocCourseService.form.getRawValue())
                .pipe(
                    tap((course: Course) => {
                        this.messageService.setRouteMessage(
                            this.translateService.instant('v3-byoc-popup-create-course-alert-created', { name: course.name }),
                            'info',
                        );
                        if (this.byocCourseService.openAfterCreate) {
                            this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'course', course.id]);
                        }
                        this.byocCourseService.close('btn-close');
                    }),
                )
                .subscribe(),
        );
    }

    saveAndAddClick(): void {
        // set as publish
        this.byocCourseService.form.patchValue({ status: 2 });

        // show loader
        this.saving = true;
        this.changeDetectorRef.detectChanges();

        // save and create Episode
        this.subscriptions.add(
            this.byocService
                .createCourse(this.byocCourseService.form.getRawValue())
                .pipe(
                    tap((course: Course) => {
                        this.messageService.setMessage(
                            this.translateService.instant('v3-byoc-popup-create-course-alert-created', { name: course.name }),
                            'info',
                        );

                        this.byocEpisodePopupService.replacePopup({
                            type: null,
                            courseId: course.id,
                            isFromOutside: true,
                            skipPosition: false,
                            uploadContentType: null,
                            episodeToEditId: null,
                            episodeToEditData: null,
                        });
                    }),
                )
                .subscribe(),
        );
    }
}
